import Loading from "@/components/Loading";
import { mapActions } from "vuex";
export default {
  components: {
    Loading
  },
  data: () => ({
    publicPath: process.env.VUE_APP_IMAGE_URL
  }),

  methods: {
    ...mapActions({
      showLoading: "setLoading"
    }),
    getImage(image) {
      if (!image) return "";
      if (image.search("http") >= 0 || image.search("blob") >= 0) {
        return image;
      } else {
        return process.env.VUE_APP_IMAGE_URL + image;
      }
    },
    downloadAs(id, fileName, folder = "cv") {
      const user = JSON.parse(localStorage.getItem("user"));
      let header = {};
      if (user) {
        header = {
          headers: {
            Authorization: `Bearer ${user.token}`
          }
        };
      }
      fetch(
        `${this.publicPath}/api/cvs/${id}/download?folder=${folder}`,
        header
      )
        .then(response => {
          if (response.ok) {
            return response.blob();
          }
          throw new Error("File not found");
        })
        .then(blob => {
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement("a");
          a.href = url;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          a.remove();
        })
        .catch(err => {
          this.$store.dispatch("setSnackBar", {
            text: err.message,
            type: "error"
          });
        });
    }
  }
};
